import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  
  private event = new BehaviorSubject<any>(undefined);

  emitChildEvent(msg: any) {
    this.event.next(msg);
  }

  childEventListner() {
    return this.event.asObservable();
  }
  clear() {
    this.event.next(undefined);
  }
}
